import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-[#57af4e] p-6 plex-regular"
}
const _hoisted_2 = { class: "container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_4 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_11 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_18 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_25 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_26 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_27 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_32 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_35 = { class: "text-sm text-red-500 p-error" }
const _hoisted_36 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_37 = { class: "text-sm text-red-500 p-error" }
const _hoisted_38 = {
  key: 2,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_39 = { class: "text-sm text-red-500 p-error" }
const _hoisted_40 = {
  key: 3,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_41 = { class: "text-sm text-red-500 p-error" }
const _hoisted_42 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_43 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_44 = { class: "text-sm text-red-500 p-error" }
const _hoisted_45 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_46 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_47 = { class: "text-sm text-red-500 p-error" }
const _hoisted_48 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_49 = { class: "text-sm text-red-500 p-error" }
const _hoisted_50 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_51 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_52 = { class: "text-sm text-red-500 p-error" }
const _hoisted_53 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_54 = { class: "text-sm text-red-500 p-error" }
const _hoisted_55 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_56 = { class: "w-full px-2" }
const _hoisted_57 = { class: "text-sm text-red-500 p-error" }
const _hoisted_58 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_59 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_60 = { class: "text-sm text-red-500 p-error" }
const _hoisted_61 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_62 = { class: "text-sm text-red-500 p-error" }
const _hoisted_63 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_64 = { class: "text-sm text-red-500 p-error" }
const _hoisted_65 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_66 = { class: "text-sm text-red-500 p-error" }
const _hoisted_67 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_68 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_69 = { class: "text-sm text-red-500 p-error" }
const _hoisted_70 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_71 = { class: "text-sm text-red-500 p-error" }
const _hoisted_72 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_75 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700",
      onInvalidSubmit: _ctx.onInvalidSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "w-full py-6" }, [
            _createElementVNode("h1", { class: "plex-semibold text-xl text-gray-800" }, "VISITANTE"),
            _createElementVNode("h1", { class: "plex-semibold text-gray-800" }, "Por favor complete el formulario en su totalidad")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)),
              _createVNode(_component_Field, {
                name: "dni",
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "DNI / Pasaporte",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_ErrorMessage, { name: "dni" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Nombre",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Apellido",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block mb-1" }, "Empresa / Profesional", -1)),
              _createVNode(_component_Field, {
                name: "empresa",
                modelValue: _ctx.formData.empresa,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Empresa",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "empresa" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block mb-1" }, "CUIT / Matrícula", -1)),
              _createVNode(_component_Field, {
                name: "cuit",
                modelValue: _ctx.formData.cuit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cuit) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "CUIT / Matrícula",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_ErrorMessage, { name: "cuit" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block mb-1" }, "Cargo", -1)),
              _createVNode(_component_Field, {
                name: "cargo",
                modelValue: _ctx.formData.cargo,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.cargo) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione el cargo",
                    options: _ctx.cargos,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_ErrorMessage, { name: "cargo" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block mb-1" }, "Mail", -1)),
              _createVNode(_component_Field, {
                name: "mail",
                modelValue: _ctx.formData.mail,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.mail) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    placeholder: "Mail",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_ErrorMessage, { name: "mail" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block mb-1" }, "Sitio web (corporativo)", -1)),
              _createVNode(_component_Field, {
                name: "website",
                modelValue: _ctx.formData.website,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.website) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Sitio web",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_ErrorMessage, { name: "website" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block mb-1" }, "Instagram / Facebook", -1)),
              _createVNode(_component_Field, {
                name: "instagramFacebook",
                modelValue: _ctx.formData.instagramFacebook,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.instagramFacebook) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Instragram / Facebook",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_ErrorMessage, { name: "instagramFacebook" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
              _createVNode(_component_Select, {
                modelValue: _ctx.selectedCountry,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                filter: "",
                options: _ctx.paises,
                optionLabel: "descripcion",
                placeholder: "Select a Country",
                class: "input-base input-success"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)),
              (_ctx.selectedCountry !== null)
                ? (_openBlock(), _createBlock(_component_InputText, {
                    key: 0,
                    type: "text",
                    modelValue: _ctx.selectedCountry.id,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedCountry.id) = $event)),
                    class: "input-base input-success",
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono comercial", -1)),
              _createVNode(_component_Field, {
                name: "telefonoComercial",
                modelValue: _ctx.formData.telefonoComercial,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.telefonoComercial) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Teléfono comercial",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_ErrorMessage, { name: "telefonoComercial" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[42] || (_cache[42] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)),
              _createVNode(_component_Field, {
                name: "telefonoCelular",
                modelValue: _ctx.formData.telefonoCelular,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Teléfono celular",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block mb-1" }, "País (Residencia)", -1)),
              _createVNode(_component_Field, {
                name: "paisResidencia",
                modelValue: _ctx.formData.paisResidencia,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.paisResidencia) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    filter: "",
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                    placeholder: "País de residencia",
                    options: _ctx.paises,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(_component_ErrorMessage, { name: "paisResidencia" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.formData.paisResidencia?.id == '+54')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)),
                  _createVNode(_component_Field, {
                    name: "provincia",
                    modelValue: _ctx.formData.provincia,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.provincia) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        placeholder: "Seleccione la provincia",
                        options: _ctx.provincias,
                        optionLabel: "descripcion",
                        class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                      _createElementVNode("span", _hoisted_35, [
                        _createVNode(_component_ErrorMessage, { name: "provincia" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formData.paisResidencia?.id != '+54')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                  _createVNode(_component_Field, {
                    name: "provinciaEstado",
                    modelValue: _ctx.formData.provinciaEstado,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Ingrese su provincia o estado",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formData.paisResidencia?.id == '+54')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[46] || (_cache[46] = _createElementVNode("label", { class: "block mb-1" }, "Localidad", -1)),
                  _createVNode(_component_Field, {
                    name: "localidad",
                    modelValue: _ctx.formData.localidad,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.localidad) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        filter: "",
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        placeholder: "Seleccione la localidad",
                        class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                        options: _ctx.localidades,
                        optionLabel: "descripcion"
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "localidad" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formData.paisResidencia?.id != '+54')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block mb-1" }, "Localidad / Ciudad", -1)),
                  _createVNode(_component_Field, {
                    name: "localidadCiudad",
                    modelValue: _ctx.formData.localidadCiudad,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.localidadCiudad) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Ingrese su localidad o ciudad",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_41, [
                        _createVNode(_component_ErrorMessage, { name: "localidadCiudad" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block mb-1" }, "Domicilio comercial", -1)),
              _createVNode(_component_Field, {
                name: "domicilioComercial",
                modelValue: _ctx.formData.domicilioComercial,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.domicilioComercial) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Domicilio comercial",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_44, [
                    _createVNode(_component_ErrorMessage, { name: "domicilioComercial" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "block mb-1" }, "Rubro", -1)),
              _createVNode(_component_Field, {
                name: "rubro",
                modelValue: _ctx.formData.rubro,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.rubro) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione el rubro",
                    options: _ctx.rubros,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_47, [
                    _createVNode(_component_ErrorMessage, { name: "rubro" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[50] || (_cache[50] = _createElementVNode("label", { class: "block mb-1" }, "¿Cómo conoció FIMAR?", -1)),
              _createVNode(_component_Field, {
                name: "tipoContacto",
                modelValue: _ctx.formData.tipoContacto,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.tipoContacto) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione como nos conoció",
                    options: _ctx.tiposContactos,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_49, [
                    _createVNode(_component_ErrorMessage, { name: "tipoContacto" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _cache[51] || (_cache[51] = _createElementVNode("label", { class: "block mb-1" }, "¿Que expo viene a visitar?", -1)),
              _createVNode(_component_Field, {
                name: "expoVisita",
                modelValue: _ctx.formData.expoVisita,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.expoVisita) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione la expo que viene a visitar",
                    options: _ctx.expos,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_52, [
                    _createVNode(_component_ErrorMessage, { name: "expoVisita" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _cache[52] || (_cache[52] = _createElementVNode("label", { class: "block mb-1" }, "¿Visitará el Salón del Mueble Argentino?", -1)),
              _createVNode(_component_Field, {
                name: "visitaSalonMueble",
                modelValue: _ctx.formData.visitaSalonMueble,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.visitaSalonMueble) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione si visita el salón del mueble",
                    options: _ctx.siNo,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_54, [
                    _createVNode(_component_ErrorMessage, { name: "visitaSalonMueble" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _cache[53] || (_cache[53] = _createElementVNode("label", { class: "block mb-1" }, "¿A qué expositor viene a vistar en la expo?", -1)),
              _createVNode(_component_Field, {
                name: "expositorVisita",
                modelValue: _ctx.formData.expositorVisita,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.expositorVisita) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Ingrese a que expositor viene a visitar",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_57, [
                    _createVNode(_component_ErrorMessage, { name: "expositorVisita" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _cache[62] || (_cache[62] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-4 md:mt-5" }, "Algunos datos sobre su comercio", -1)),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _cache[54] || (_cache[54] = _createElementVNode("label", { class: "block mb-1" }, "¿Tiene showroom?", -1)),
              _createVNode(_component_Field, {
                name: "tieneShowroom",
                modelValue: _ctx.formData.tieneShowroom,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.tieneShowroom) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    options: _ctx.siNo,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_60, [
                    _createVNode(_component_ErrorMessage, { name: "tieneShowroom" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _cache[55] || (_cache[55] = _createElementVNode("label", { class: "block mb-1" }, "¿Vende por e-commerce?", -1)),
              _createVNode(_component_Field, {
                name: "vendePorEcommerce",
                modelValue: _ctx.formData.vendePorEcommerce,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.vendePorEcommerce) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    options: _ctx.siNo,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_62, [
                    _createVNode(_component_ErrorMessage, { name: "vendePorEcommerce" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _cache[56] || (_cache[56] = _createElementVNode("label", { class: "block mb-1" }, "¿Tiene sucursales?", -1)),
              _createVNode(_component_Field, {
                name: "tieneSucursales",
                modelValue: _ctx.formData.tieneSucursales,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.tieneSucursales) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    options: _ctx.siNo,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_64, [
                    _createVNode(_component_ErrorMessage, { name: "tieneSucursales" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _cache[57] || (_cache[57] = _createElementVNode("label", { class: "block mb-1" }, "¿Pertenece a una red u organización?", -1)),
              _createVNode(_component_Field, {
                name: "perteneceRed",
                modelValue: _ctx.formData.perteneceRed,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.perteneceRed) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione una opción",
                    options: _ctx.siNo,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_66, [
                    _createVNode(_component_ErrorMessage, { name: "perteneceRed" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _withDirectives(_createElementVNode("div", _hoisted_68, [
              _cache[58] || (_cache[58] = _createElementVNode("label", { class: "block mb-1" }, "Especifique cuantas sucursales tiene", -1)),
              _createVNode(_component_Field, {
                name: "cantidadSucursales",
                modelValue: _ctx.formData.cantidadSucursales,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.cantidadSucursales) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Cantidad de sucursales",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_69, [
                    _createVNode(_component_ErrorMessage, { name: "cantidadSucursales" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 512), [
              [_vShow, _ctx.formData.tieneSucursales != undefined && _ctx.formData.tieneSucursales.id === 1]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_70, [
              _cache[59] || (_cache[59] = _createElementVNode("label", { class: "block mb-1" }, "¿Cuál es el nombre de la organización a la que pertenece?", -1)),
              _createVNode(_component_Field, {
                name: "nombreRed",
                modelValue: _ctx.formData.nombreRed,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.nombreRed) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Nombre de la red",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_71, [
                    _createVNode(_component_ErrorMessage, { name: "nombreRed" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 512), [
              [_vShow, _ctx.formData.perteneceRed != undefined && _ctx.formData.perteneceRed.id === 1]
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("button", {
              type: "submit",
              class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_74, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_75, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _cache[60] || (_cache[60] = _createTextVNode("REGISTRARME ", -1))
            ], 8, _hoisted_73)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
  ]))
}